import { Row, Col, Tabs, message } from "antd";
import axios from "axios";
import { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DataContext from "../../../Context/dataContext";
import BasicDetails from "./Issueheaderdetails";
import SyncLoader from "react-spinners/SyncLoader";
import classes from "../Pages.module.css";
import dayjs from "dayjs";
// import dayjs from "dayjs";

const { TabPane } = Tabs;


const IssueReturnNew = () => {
  const employeeData = useContext(DataContext);
  const history = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(true);

  const [allData, setAllData] = useState({
    OutWard: [
      {
        gpDate: dayjs(new Date()).format("DD-MM-YYYY"),
        pendingInward: null,
        truckNo: null,
        totalWeight: null,
        tareWeight: null,
        netWeight: null,
        invoiceCode: null,
        gateSlipNo: null,
        driverName: null,
        challanNo: null,
        challanDate: null,
        d_code: null,
        dept_code: null,
        depttcode: null,
        dcccode: null,
        customer: null,
      },
    ],
    outDetail: [],
  });
  const [ad, setAD] = useState(null);

  useEffect(() => {
    fetchAdditionalData();
  }, []);

  const fetchAdditionalData = () => {
    setLoading(true);
    axios
      .get(employeeData.URL + "/api/v1/outwardgatepassdata/additional-data", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response.data);
        setAD(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching additional data:", error);
        setLoading(false);
      });
  };

  const handleSave = () => {
    let formValid = true;

    if (formValid) {
      setLoading(true);

      const postData = {
        ...allData,
      };
      console.log("asdfghjk", postData);
      // Validate postData fields
      const validationErrors = [];

      // Ensure OutWard array exists and has at least one item
      if (!postData.OutWard || postData.OutWard.length === 0) {
        validationErrors.push("OutWard data is required.");
      } else {
        postData.OutWard.forEach((item, index) => {
          if (!item.gpDate) {
            validationErrors.push(`gpDate is required for item ${index + 1}.`);
          }
          if (item.pendingInward === undefined || item.pendingInward === null) {
            validationErrors.push(`pending Inward`);
          }
          if (!item.truckNo) {
            validationErrors.push(`truckNo`);
          }
          if (!item.invoiceCode) {
            validationErrors.push(`invoiceCode`);
          }
          if (!item.gateSlipNo) {
            validationErrors.push(`gateSlipNo`);
          }
          if (!item.driverName) {
            validationErrors.push(`driverName`);
          }
          if (!item.customer) {
            validationErrors.push(`customer`);
          }
        });
      }

      // If there are validation errors, show a message and stop the process
      if (validationErrors.length > 0) {
        setLoading(false); // Stop loading state
        message.error({
          content: validationErrors.join(", "),
          className: "custom-class",
          style: {
            marginTop: "2vh",
          },
        });
        return; // Exit the function
      }

      console.log("Post Data:", postData);

      axios
        .post(
          employeeData.URL + "/api/v1/outwardgatepassdata/savedogdata",
          postData,
          {
            withCredentials: true,
            credentials: "include",
          }
        )
        .then((response) => {
          message.success({
            content: "Outward saved Succesfully!!!",
            className: "custom-class",
            style: {
              marginTop: "2vh",
            },
          });
          setLoading(false);
          history("/gate/transaction/outward-view");
        })
        .catch((error) => {
          console.error("Error creating Return:", error);
          message.error({
            content: "An Error Occurred!!!!",
            className: "custom-class",
            style: {
              marginTop: "2vh",
            },
          });
          setLoading(false);
        });
    }
  };

  const handleCancel = () => {
    setLoading(false);

    if (location.search === "?outward") {
      // Navigate to /sales/dashboard
      history("/gate/dashboard");
    } else {
      // Fallback to another route if needed
      history("/gate/transaction/outward-view");
    }
  };

  return (
    <>
      {ad ? (
        <Row className={classes.RowP}>
          <Col
            lg={editMode ? 13 : 19}
            md={editMode ? 13 : 19}
            className={classes.Col}
          ></Col>
          {editMode ? (
            <>
              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleSave(event)}
                    className={classes["ProfileButtonn"]}
                    id="save"
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                  >
                    Save
                  </button>
                )}
              </Col>

              <Col md={4}>
                {loading ? (
                  <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                ) : (
                  <button
                    style={{
                      padding: "7px 30px 14px 24px",
                      borderRadius: "50px",
                      background: "transparent",
                      width: "100%",
                      border: "none",
                      outline: "none",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "1.5",
                      color: "#071e54",
                      WebkitAppearance: "none",

                      boxShadow:
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                      height: "40px",

                      // Ensure the button takes full width
                    }}
                    onClick={(event) => handleCancel(event)}
                    onMouseOver={(event) => {
                      event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                    }}
                    onMouseOut={(event) => {
                      event.target.style.boxShadow =
                        "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                    }}
                    className={classes["ProfileButtonn"]}
                  >
                    Cancel
                  </button>
                )}
              </Col>
            </>
          ) : (
            <Col md={4}>
              <button
                onClick={() => setEditMode(true)}
                className={classes.ProfileButton}
              >
                Edit Details
              </button>
            </Col>
          )}
          <Col lg={1} md={1}></Col>
          <Col lg={24} md={24} className={classes.Col}>
            <div className={classes.EditView}>
              <Tabs
                defaultActiveKey="0"
                centered
                style={{ height: "100%" }}
                tabPosition="left"
                type="line"
                tabBarGutter="0"
              >
                <TabPane tab={<span>Gate Pass Outward</span>} key="0">
                  <BasicDetails
                    create={true}
                    ad={ad}
                    setData={setAllData}
                    data={allData.OutWard[0]}
                    editMode={editMode}
                  />
                </TabPane>
                {/* Uncomment this when VDetailPart component is implemented */}
                {/* <TabPane tab={<span>Issue Detail</span>} key="1">
                  <VDetailPart
                    ad={ad}
                    setData={setAllData}
                    data={allData.IssueDetail}
                    editMode={editMode}
                  />
                </TabPane> */}
              </Tabs>
            </div>
          </Col>
        </Row>
      ) : (
        <>
          <SyncLoader color={"rgba(255, 163, 77, 0.8)"} size={10} />
          <SyncLoader color={"rgba(255, 163, 77, 0.8)"} size={10} />
          <SyncLoader color={"rgba(255, 163, 77, 0.8)"} size={10} />
          <SyncLoader color={"rgba(255, 163, 77, 0.8)"} size={10} />
        </>
      )}
    </>
  );
};

export default IssueReturnNew;
